const initialState = {
  feedbacks: [],
  page: 0,
  totalPages: 0,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCH_FEEDBACKS":
      return {
        ...state,
        feedbacks: [...state.feedbacks, ...payload.feedbacks],
        totalPages: payload.pages_count,
        page: state.page + 1,
      };

    default:
      return state;
  }
};
